import React from 'react';
import { connect } from 'react-redux';
import './index.scss';
import Logger from '../../../common/logger';
import PopupLayer from '../layers/popup';
import WidgetLayer from '../layers/widget';

class Main extends React.Component {
    constructor() {
        super();
        this.state = {
            isTabbedNavigation: false
        };
        this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
        this.onMouseUpHandler = this.onMouseUpHandler.bind(this);
        this.onResize = this.onResize.bind(this);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onKeyDownHandler);
        document.addEventListener('mouseup', this.onMouseUpHandler);
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDownHandler);
        document.removeEventListener('click', this.onMouseUpHandler);
        window.removeEventListener('resize', this.onResize);
    }

    onKeyDownHandler(event) {
        if (event.key === 'Tab' && !this.state.isTabbedNavigation) {
            this.setState({ isTabbedNavigation: true });
        }
    }

    onMouseUpHandler() {
        if (this.state.isTabbedNavigation) {
            this.setState({ isTabbedNavigation: false });
        }
    }

    onResize() {
        const activeElement = document.activeElement;
        if (activeElement) {
            activeElement.scrollIntoView({ behavior: 'smooth' });
        }
    }

    render() {
        const { main, settings, debugGWE } = this.props;
        const style = {
            width: main.mainWidth,
            height: main.mainHeight
        };

        Logger.setDebugGWE(debugGWE);
        const classes =
            main.device.toLowerCase() +
            ' ' +
            (settings && settings.widget && settings.widget.theme
                ? settings.widget.theme
                : 'default') +
            (this.state.isTabbedNavigation ? ' tabbed' : '');

        //--TODO: error handling:
        //  https://reactjs.org/blog/2017/07/26/error-handling-in-react-16.html

        return (
            <div style={style} className={classes}>
                {main.isPopupLayerEnabled ? <PopupLayer /> : null}
                {main.isWidgetLayerEnabled ? <WidgetLayer /> : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        main: state.main,
        settings: state.settings,
        debugGWE:
            (state && state.config && state.config.widget && state.config.widget.debugGWE) || false
    };
};

export default connect(mapStateToProps)(Main);
